import { ProductProvider } from "../Context/ProductContext";
import ProductList from "./ProductList";

function Product(){
    return(
        <>
        <ProductProvider>
            <ProductList/>
        </ProductProvider>
        </>
    )
}

export default Product